import { render, staticRenderFns } from "./overseasIndex.vue?vue&type=template&id=01bbbace&scoped=true"
import script from "./overseasIndex.vue?vue&type=script&lang=js"
export * from "./overseasIndex.vue?vue&type=script&lang=js"
import style0 from "./overseasIndex.vue?vue&type=style&index=0&id=01bbbace&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bbbace",
  null
  
)

export default component.exports